import { type TenantBrandingColors } from "../types";

export const branding: TenantBrandingColors = {
  auth: {
    authBackgroundColor: {
      light: "rgba(31, 36, 48, 1)",
      dark: "rgba(31, 36, 48, 1)",
    },
    authColor: "#ffffff",
    authBorderColor: "rgba(214, 220, 225, 0.2)",
  },
  backgroundColor: "#EBEBEB",
  brandDefault: {
    light: "#4A56A8",
    dark: "#4A56A8",
  },
  brandHover: {
    light: "#3B4589",
    dark: "#3B4589",
  },
  brandActive: {
    light: "#2F3870",
    dark: "#2F3870",
  },
  brandOpacity: {
    light: "rgba(74, 86, 168, 0.2)",
    dark: "rgba(74, 86, 168, 0.2)",
  },
  dataColors: {
    light: ["#4B5369", "#CBC6B9", "#73A1D3", "#CEB9F0", "#93867B"],
    dark: ["#4B5369", "#CBC6B9", "#73A1D3", "#CEB9F0", "#93867B"],
  },
};
